import { render, staticRenderFns } from "./product-sociolla.vue?vue&type=template&id=138f9059&scoped=true"
import script from "./product-sociolla.vue?vue&type=script&lang=js"
export * from "./product-sociolla.vue?vue&type=script&lang=js"
import style0 from "./product-sociolla.vue?vue&type=style&index=0&id=138f9059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f9059",
  null
  
)

export default component.exports